<template>
  <div class="main common_bg">
    <p class="title">
      <span>消息</span>
    </p>
    <div class="content" :class="{'bg':!loadErrorShow && !noNetworkShow}">
      <div class="box" v-show="data">
        <img class="user_icon" :src="data.teacher_avatar || '/static/img/common/defaultTeacherImg.png'" alt>
        <div class="cont">
          <p class="tit">
            <span class="msg-title">{{data.title}}</span>
            <span class="date">{{data.create_time|format}}</span>
          </p>
          <p class="display">{{data.content}}</p>
          <div class="me_box">
            <h2>{{data.comments?'你的评价':''}} </h2>
            <p class="me_content">{{data.comments || '你在评价时未填写内容'}}</p>
            <p class="detail"><span>{{data.lesson_name}}</span><span>{{data.real_name}}老师</span><span>上课时间：{{data.real_begin_time}}</span></p>
          </div>
        </div>
      </div>
      <loadError @loadAgain="getData" v-if="loadErrorShow" loadErrorText="消息详情获取失败，请点击按钮重新加载～"/>
      <noNetwork v-if="noNetworkShow"/>
    </div>

    <Back @goBack="goBack"/>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import noNetwork from "./noNetwork.vue";
import loadError from "../../basic/loadError";

import { mapState, mapMutations, mapActions } from "vuex";
import utils from "@/js/utils.js";
export default {
  data() {
    return {
      data: "",
      loadErrorShow: false,
      noNetworkShow: false
    };
  },
  components: {
    Back,
    noNetwork,
    loadError
  },
  filters: {
    format(value) {
      return value && utils.dateFormat("YY-mm-dd HH:MM:SS", new Date(value*1000));
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions(["getMsgDetail"]),
    getData() {
      this.loadErrorShow = false;
      this.noNetworkShow = !navigator.onLine;
      if (this.noNetworkShow) return;
      this.getMsgDetail({ id: this.$route.query.id })
        .then(({ res, ok }) => {
          if (ok) {
            this.data = res;
          }
        })
        .catch(e => {
          this.loadErrorShow = true;
        });
    },
    goBack() {
      this.$router.push("/msg");
    },
    del(index) {
      this.source.splice(index, 1);
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 60px;
  .menu {
    position: fixed;
  }
  .title {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: #0089ce;
    font-size: 26px;
    color: #fff;
    position: relative;
    margin-bottom: 15px;
    position: relative;
    .edit {
      position: absolute;
      right: 40px;
      font-size: 20px;
    }
  }
  .bg {
    background: #f1f3f4;
  }
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 1024px;
    height: 100%;
    border-radius: 20px;
    padding-left:20px;
    overflow:hidden;
    .box {
      width:100%;
      display: flex;
      padding: 50px 20px 0 30px;
      text-align: left;
      overflow-y:scroll;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 6px;
        box-shadow: inset 0 0 5px #d7d7d7;
        background: #d7d7d7;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        background: #f1f3f4;
      }
      .cont{
        width:100%;
        padding-right:50px;
      }
      .user_icon {
        height: 64px;
        width: 64px;
        min-width: 64px;
        border-radius: 50%;
        border: 1px solid #c0d1d6;
        margin-right: 20px;
        margin-top:6px;
        vertical-align: middle;
      }
      .tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding:5px 0 18px 0;
        .msg-title {
          font-size: 18px;
          color: #333;
          font-weight: 700;
          font-size: 21px;
          overflow: hidden;
          height: 24px;
          line-height: 24px;
          padding-right: 80px;
        }
        .date {
          text-align: right;
          height: 24px;
          line-height: 24px;
          min-width: 170px;
          color: #b3b3b3;
          font-size: 16px;
        }
      }
      .display {
        color: #666;
        font-size: 20px;
        line-height: 1.4;
        text-align: left;
        white-space: pre-wrap;
        overflow: hidden;
        word-break: break-all
      }
      .me_box{
        border-top:1px solid #E4E4E4;
        margin-top:20px;
        padding-bottom:20px;
        color:#999999;
        h2{
          font-size:20px;
          padding-top:30px;
        }
        .me_content{
          padding: 18px 0 20px 0;
          font-size: 20px;
          line-height: 1.4;
          word-break: break-all
        }
        .detail span{
          padding-right:20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/message/messageDetail.vue